export default __webpack_public_path__ + "static/excess_insurance_paragraph-1ef87c43497eae54dc94505ef394b4cd.jpeg";